import React, { Component } from "react";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem, MyProfileBCItem } from "@my-dld/contexts/PageContext";
import { getEmail } from "@10x/sso";
import { trackEvent } from "@my-dld/utils/Analytics";
import { getError, hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { NullHandler } from "@my-dld/utils/ApiUtils";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { setSSOUser } from "@my-dld/utils/User";
import { AppConstants } from "../../../configApp";
import { getAppServices } from "@10x/coreapp";
import moment, { Moment } from "moment/moment";
import { toClockString } from "../../Register/VerifyPopup";


interface Props extends RoutedViewProps<any, { skipWait: boolean; showDone: boolean }> {
	showNDA?: boolean
}

const loginInfo: { canSendOTP: boolean; isSendingOtp: boolean; timeOut: any } = {
	canSendOTP: true,
	isSendingOtp: false,
	timeOut: undefined,
};

function onOTPGenerated() {
	loginInfo.canSendOTP = false;
	if ( loginInfo.timeOut ) {
		clearTimeout( loginInfo.timeOut );
	}
	loginInfo.timeOut = setTimeout( () => {
		loginInfo.canSendOTP = true;
		loginInfo.isSendingOtp = false;
	}, 20 * 1000 );
}

interface State {
	email: string;
	showOTP: boolean;
	otp: string;
	error?: string;
	sendFailed?: boolean;
	remainTime?: string;
	resending: boolean;
	otpStatus?: boolean;
	showNDA?: boolean;
}

class VerifyAccount extends Component<Props, State> {
	apiHandler = NullHandler;
	apiExHandler = NullHandler;

	resendDate?: Moment;
	resendTimer?: any;

	loadTimeOut: any = undefined;

	constructor( props: Props ) {
		super( props );
		const showNDA = getAppServices().storeService.getStore().getState().User.showNDA;
		this.state = {
			email: getEmail()!,
			showOTP: false,
			otp: "",
			error: undefined,
			sendFailed: false,
			resending: false,
			showNDA: showNDA
		};
	}

	componentDidMount() {
		showLoading();
		this.loadTimeOut = setTimeout( () => {
			hideLoading();
			this.loadTimeOut = undefined;
			this.sendOTP();
		}, 1000 );
	}

	componentWillUnmount() {
		this.apiHandler = NullHandler;
		this.apiExHandler = NullHandler;
		if ( this.loadTimeOut ) {
			hideLoading();
			clearTimeout( this.loadTimeOut );
		}
		if ( this.resendTimer ) {
			clearTimeout( this.resendTimer );
			this.resendTimer = 0;
		}
	}

	render() {
		const { email, showOTP, otp, error, sendFailed } = this.state;
		return <PageContent title={ Strings.verify_email } hideQLinks={ true }>
			<PageTitle title={ Strings.verify_email } paths={ [ DashboardBCItem, MyProfileBCItem ] }/>
			{ sendFailed && <>
				<div className="msg-wrapper mb-5">
					<div className="msg-wrapper-inner">
						{ error && <div className={ "d-flex flex-align-center" }>
							<div className={ "alert alert-danger mb-2" }>
								{ error }
							</div>
						</div> }

						<div className="text-center mt-3">
							<button disabled={ this.state.otpStatus } className="btn btn_1 btn_style1" onClick={ this.sendOTP }>
								{ ( this.state.resending ) ? <div className="relative spinner-border " role="status">
                            <span
	                            className="sr-only"
	                            style={ { color: this.state.otpStatus ? "#9f9f9f" : "#ffffff" } }>{ Strings.loading }</span>
								</div> : Strings.resend_otp + ( this.state.remainTime ? `\n${ this.state.remainTime }` : "" ) }
							</button>
						</div>
					</div>
				</div>
			</> }
			{ showOTP && <>
				<div className="msg-wrapper mb-5">
					<div className="msg-wrapper-inner">
						<div className="text-center">
							<img
								alt={ "otp" }
								className="mt-3 mb-3"
								src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
						</div>
						<div className="text-center">
							<strong>{ Strings.verification }</strong>
						</div>

						<p className="mt-2 text-center">{ Strings.please_enter_the_otp_on } &nbsp; { email }</p>
						<div className="form-group field-style mb-4 text-center">
							<input
								className="form-control text-center otp-field" placeholder="******"
								value={ otp }
								onChange={ ( e ) => {
									let value = e.target.value;
									let mx = e.target.maxLength;
									if ( mx != null && mx !== -1 ) {
										if ( value && value.length > mx ) {
											value = value.slice( 0, mx );
										}
									}
									this.setState( {
										otp: value,
									} );
								} }
								maxLength={ 6 }
								type="password"/>
						</div>
						{ error && <div className={ "d-flex flex-align-center" }>
							<div className={ "invalid-feedback invalid-feedback-x" }>
								{ error }
							</div>
						</div> }

						<div className="form-group mb-4 mb-0 text-center">
							<button className="btn btn_1 btn_style1" onClick={ this.onVerify }>{ Strings.verify }</button>
						</div>

						<div className="form-group mb-4 mb-0 text-center">
							<button
								disabled={ this.state.otpStatus }
								className="btn btn_1 otp-btn"
								type="button" onClick={ this.sendOTP }>
								{ ( this.state.resending ) ? <div className="relative spinner-border " role="status">
                            <span
	                            className="sr-only"
	                            style={ { color: this.state.otpStatus ? "#9f9f9f" : "#ffffff" } }>{ Strings.loading }</span>
								</div> : Strings.resend_otp + ( this.state.remainTime ? `\n${ this.state.remainTime }` : "" ) }
							</button>
						</div>
					</div>
				</div>
			</> }

		</PageContent>;
	}

	setError = ( e?: string ) => {
		this.setState( { error: e } );
	};
	onVerify = () => {
		const { otp } = this.state;
		showLoading();
		SSOApi.profile.verifyAccountOtp( { email: otp } )
		.then( r => {
			hideLoading();
			if ( r.data.email?.status === "VERIFIED" ) {
				this.onVerified();
			} else {
				this.setError( Strings.invalid_otp );
			}
		} ).catch( e => {
			return exToMessage( e )
			.then( msg => {
				hideLoading();
				this.setError( msg.error ?? msg );
			} );
		} );
	};

	onVerified = () => {
		setTimeout( () => {
			showLoading();
			SSOApi.profile.me().then( r => {
				setSSOUser( r.data );
				hideLoading();
				if (this.state.showNDA) {
					replaceNavigate("/mydld/nda");
				} else {
					replaceNavigate( "/mydld" );
				}
			} ).catch( ( ex: any ) => {
				return exToMessage( ex ).then( msg => {
					hideLoading();
					showErrorMessage( msg.error ?? ex );
				} );
			} );
		}, 10 );
	};


	sendOTP = () => {
		if ( loginInfo.isSendingOtp ) {
			setTimeout( () => {
				this.sendOTP();
			}, 2000 );
			return;
		}
		if ( !loginInfo.canSendOTP ) {
			this.setState( { showOTP: true } );
			return;
		}
		loginInfo.isSendingOtp = true;
		showLoading();
		this.setState( { sendFailed: false } );
		this.apiHandler = response => {
			this.resetOTPTimer();
			this.setState( {
				otp: "", resending: false,
				otpStatus: true,
				error: undefined, sendFailed: false,
			} );
			hideLoading();
			trackEvent( "VerifyAccount", "EmailOTPSend" );
			this.setState( { showOTP: true } );
			onOTPGenerated();
			loginInfo.isSendingOtp = false;
			return response;
		};
		this.apiExHandler = ( ex: any ) => {
			trackEvent( "VerifyAccount", "EmailOTPSendError" );
			this.resetOTPTimer();
			this.setState( {
				otp: "", resending: false,
				otpStatus: true,
			} );
			return exToMessage( ex ).then( msg => {
				hideLoading();
				loginInfo.isSendingOtp = false;
				loginInfo.canSendOTP = true;
				const m = getError( msg.error ?? ex );
				this.setState( { showOTP: false, sendFailed: true, error: m } );
			} );
		};
		SSOApi.profile.initAccountVerify( {
			email: this.state.email,
		} )
		.then( this.apiHandler )
		.catch( this.apiExHandler );
	};


	updateResendLabel = () => {
		if ( this.resendDate ) {
			const diff = this.resendDate.diff( new Date() );
			if ( diff > 0 ) {
				let duration = moment.duration( diff );
				this.setState( {
					remainTime: toClockString( duration.hours() ) + ":" + toClockString( duration.minutes() )
						+ ":" + toClockString( duration.seconds() ),
				} );
			} else {
				if ( this.resendTimer ) {
					clearTimeout( this.resendTimer );
				}
				this.setState( {
					remainTime: undefined,
					otpStatus: false,
				} );
			}
		}
	};

	private resetOTPTimer() {
		this.resendDate = moment( new Date() ).add( 1, "minutes" );
		this.resendTimer = setInterval( this.updateResendLabel, 500 );
	}
}

export default VerifyAccount;
